import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM, CUST_GRADIENTS } from '../../../../theme/customizer-tokens';

/** Fixed row height, shared with the loading skeleton so the shimmer placeholder
 *  is exactly as tall as a real row (padding + borders + the "Free" pill). */
export const DOMAIN_ROW_HEIGHT = 56;

export const Row = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  height: ${DOMAIN_ROW_HEIGHT}px;
  padding: 16px 24px;
  text-align: left;
  cursor: pointer;
  border: 1px solid ${({ $selected }) => ($selected ? CUST.accent : 'transparent')};
  border-radius: 16px;
  /* Selected row gets the orange-glow surface; unselected stays solid dark. */
  background: ${({ $selected }) => ($selected ? CUST_GRADIENTS.suggestionSelected : CUST.cardSurface)};
  transition: border-color ${CUST_ANIM.INTERACT_MS}ms ease;
`;

export const Domain = styled(Text)`
  min-width: 0;
  font-size: 16px;
  line-height: 1.2;
  color: ${CUST.white};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Right-side cluster: the (struck-out) list price + the green "Free" tag. */
export const PriceCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
`;

/** The original list price, struck through — every suggested domain is free
 *  during onboarding, so the amount is shown crossed out, not charged. */
export const Price = styled(Text)`
  font-size: 16px;
  line-height: 1.2;
  font-weight: 500;
  color: ${CUST.textMuted};
  text-decoration: line-through;
  white-space: nowrap;
`;

/** Green "Free" pill, reusing the progress "Done" chip's success tone. */
export const FreeTag = styled(Text)`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 600;
  color: ${CUST.freeColor};
  background: ${CUST.doneChipBg};
  white-space: nowrap;
`;